import React from 'react';

import { ISecondary } from '../types';

const LogoHeader: React.FC<ISecondary> = () => null;

export default LogoHeader;
